<template>
  <v-overlay
    v-model="loading"
    :persistent="props.persistent"
    class="align-center justify-center"
  >
    <v-progress-circular
      :color="props.color"
      :size="props.size"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup lang="ts">
type LoadingOverlayProps = {
  size?: string | number
  color?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error'
}

const props = withDefaults(defineProps<LoadingOverlayProps>(), {
  size: 64,
  color: 'primary',
  persistent: false,
})

const loading = defineModel<boolean>('loading')
</script>
